import Header from '@/components/Layout/Header';
import MenuLayout from '@/components/Layout/MenuLayout.tsx';
import { Box, Button, Stack, Typography } from '@mui/material';
import { CrmPage } from '../CrmPage/CrmPage';
import { Add } from '@mui/icons-material';
import { TypesCRM } from '@/types/crm.ts';

const Home = () => {
  return (
    <div>
      <Header />
      <MenuLayout />
      <div
        style={{
          marginTop: '80px',
          width: 'calc(100% - 300px)',
          marginLeft: '300px',
          padding: '0 15px',
          marginBottom: '-73px',
        }}
      >
        <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
          <Typography variant="h3" margin={'30px 0'} color={"#000"}>
            CRM Matrícula
          </Typography>
          <Button
            sx={{
              p: '0 5px',
              borderRadius: '24px',
              fontSize: '14px',
              height: '37px',
              color: '#fff !important',
              weight: '600',
              background: '#15AB51',
              textTransform: 'capitalize'
            }}
            variant="contained"
          >
            <Add />
            Cadastrar responsável financeiro
          </Button>
        </Stack>
        <Box
          padding={'15px'}
          sx={{
            border: '1px solid rgba(176, 176, 176, 1)',
            background: '#fff',
            borderRadius: '14px',
          }}
        >
          <CrmPage title={'CRM'} type={TypesCRM.MATRICULA} />
        </Box>
      </div>
    </div>
  );
};

export default Home;
